import React from 'react';
import { getPadelGamesPairForMatch } from '../utils/padelGameTotals';

/**
 * Admin match list: show per-team games won/lost from set lines (standings tiebreaker).
 * Pass the same styled Detail* components used in the parent card.
 */
export function MatchPadelGamesDetail({ match, DetailItem, DetailLabel, DetailValue }) {
  const padel = getPadelGamesPairForMatch(match);
  if (!padel) return null;
  const n1 = match.team1_name || 'Team 1';
  const n2 = match.team2_name || 'Team 2';
  return (
    <DetailItem style={{ gridColumn: '1 / -1' }}>
      <DetailLabel>Games (tiebreaker)</DetailLabel>
      <DetailValue>
        <div style={{ fontSize: '0.8125rem', lineHeight: 1.55, color: '#374151' }}>
          <div>
            <strong>{n1}:</strong> {padel.team1.gw} won, {padel.team1.gl} lost
          </div>
          <div>
            <strong>{n2}:</strong> {padel.team2.gw} won, {padel.team2.gl} lost
          </div>
        </div>
      </DetailValue>
    </DetailItem>
  );
}
